module.exports = __webpack_public_path__ + "img/map_toilet_2@2x.260b31d9.png";